module.exports = __webpack_public_path__ + "static/geschaeftsreisen-ca2f03a83d90f6315783ef44894a6b2e.svg";